/**
 * Environment Configuration
 * Validates and exports environment variables with type safety
 */

interface EnvConfig {
  sheetsApiUrl: string
  appName: string
  appVersion: string
  enableOfflineMode: boolean
  enableDebug: boolean
  maxImageSizeMB: number
  imageQuality: number
}

/**
 * Validate and parse environment variables
 */
function validateEnv(): EnvConfig {
  const config: EnvConfig = {
    sheetsApiUrl: import.meta.env.VITE_SHEETS_API_URL || '',
    appName: import.meta.env.VITE_APP_NAME || 'SPT Driver',
    appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
    enableOfflineMode: import.meta.env.VITE_ENABLE_OFFLINE_MODE === 'true',
    enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    maxImageSizeMB: Number(import.meta.env.VITE_MAX_IMAGE_SIZE_MB) || 5,
    imageQuality: Number(import.meta.env.VITE_IMAGE_QUALITY) || 0.8,
  }

  // Validate critical values
  if (config.imageQuality < 0 || config.imageQuality > 1) {
    console.warn('Invalid VITE_IMAGE_QUALITY, using default 0.8')
    config.imageQuality = 0.8
  }

  if (config.maxImageSizeMB <= 0) {
    console.warn('Invalid VITE_MAX_IMAGE_SIZE_MB, using default 5MB')
    config.maxImageSizeMB = 5
  }

  // Warn if critical configs are missing
  if (!config.sheetsApiUrl && import.meta.env.PROD) {
    console.warn('VITE_SHEETS_API_URL not configured - Google Sheets sync will not work')
  }

  return config
}

export const env = validateEnv()
